export default "__VITE_ASSET__CRSr2gpd__"